(() => {
  const initGuide = (guide) => {
    if (guide.dataset.bvtCaratInitialized === 'true') return;
    const stone = guide.querySelector('.bvt-carat-guide__stone');
    const current = guide.querySelector('.bvt-carat-guide__current');
    const buttons = [...guide.querySelectorAll('[data-bvt-carat-option]')];
    const rotation = Number(guide.getAttribute('data-bvt-carat-rotation') || -59);
    if (!stone || !current || !buttons.length) return;
    guide.dataset.bvtCaratInitialized = 'true';

    const selectCarat = (value) => {
      const scale = Math.cbrt(value / 2);
      stone.style.transform = `translate(-50%, -50%) rotate(${rotation}deg) scale(${scale.toFixed(4)})`;
      current.textContent = `${value.toFixed(1)} ct`;
      buttons.forEach((button) => {
        button.setAttribute('aria-pressed', String(Number(button.dataset.bvtCaratOption) === value));
      });
    };

    buttons.forEach((button) => button.addEventListener('click', () => selectCarat(Number(button.dataset.bvtCaratOption))));
    selectCarat(2);
  };

  const placeGuideAsSixthMediaTile = (guide) => {
    const guideTile = guide.closest('.bvt-carat-guide__slide') || guide;
    const container = guideTile.parentElement;
    if (!container) return;

    const mediaTiles = [...container.children].filter((tile) => (
      tile !== guideTile && tile.hasAttribute('data-media-id')
    ));
    const sixthTileAnchor = mediaTiles[4];
    if (sixthTileAnchor) {
      sixthTileAnchor.after(guideTile);
    } else if (mediaTiles.length) {
      mediaTiles.at(-1).after(guideTile);
    }
  };

  const guides = [...document.querySelectorAll('[data-bvt-carat-guide]')];
  guides.forEach(initGuide);
  guides.forEach(placeGuideAsSixthMediaTile);
})();
